import type { Role } from '@ooh/contracts';

/**
 * Resolves the active role for the permission-matrix screen: the explicit
 * selection if it still exists in `roles`, else the first role in the list,
 * else `null` (empty catalog).
 */
export function resolveSelectedRole(roles: Role[], selectedRoleCode: string | null): Role | null {
  const code = selectedRoleCode ?? roles[0]?.code ?? null;
  if (code === null) return null;
  return roles.find((r) => r.code === code) ?? null;
}
